import * as React from "react";

export interface ILoadingProps {
    error: Error;
}

const Loading: React.SFC<ILoadingProps> = (props: ILoadingProps) => {

    return (
        <React.Fragment>
            <h1>Loading...</h1>
            {props.error &&
                <div>Error:
                    <div>Name: {props.error.name}</div>
                    <div>Message: {props.error.message}</div>
                    <div>Stack: {props.error.stack}</div>
                </div>
            }
        </React.Fragment>
    );
};

export { Loading as default, Loading };
